import { IUploadExcelRequest } from '../../models/request/bus/uploadExcelRequest';
import { bus_diemdontra } from '../../models/response/bus/bus_diemdontra';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_DIEMDONTRA_PATH = "bus/diem-don-tra";

export interface IBusDiemDonTraSelectByTuyenDuongRequest {
	bus_tuyenduong_id: number;
	bus_loaidiemdon_id: number;
}

class BusDiemDonTraApi extends BaseCRUDApi<bus_diemdontra> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/diem-don-tra`);
	}
	Select(request: IBusDiemDonTraSelectByTuyenDuongRequest) {
		return apiClient.post(`${API_BUS_DIEMDONTRA_PATH}/select-by-tuyenduong`, {
			bus_tuyenduong_id: request.bus_tuyenduong_id,
			bus_loaidiemdon_id: request.bus_loaidiemdon_id,
		});
	}
	Import(request: IUploadExcelRequest) {
		return apiClient.put(`bus/diem-don-tra/import`, request);
	}
	ValidateImport(request: IUploadExcelRequest) {
		return apiClient.put(`bus/diem-don-tra/validate-import`, request);
	}
	Search(search_key: string) {
		return apiClient.get(`bus/diem-don-tra/search?search_key=${search_key}`);
	}
	SearchDetail(diem_don_tra: string) {
		return apiClient.get(`bus/diem-don-tra?search_key=${diem_don_tra}`);
	}
}
export const busDiemDonTraApi = new BusDiemDonTraApi(API_BUS_DIEMDONTRA_PATH);
